export default __webpack_public_path__ + "files/media/boarding.0454704f.jpg";